const JOB_STATUS_IDS = {
    DRAFT: 10,
    IN_PROGRESS: 20,
    CLOSED: 40,
    CANCELLED: 50
} as const

export type JobStatusId = (typeof JOB_STATUS_IDS)[keyof typeof JOB_STATUS_IDS]

const JOB_LIST_FILTER_STATUS_IDS = [
    JOB_STATUS_IDS.DRAFT,
    JOB_STATUS_IDS.IN_PROGRESS,
    JOB_STATUS_IDS.CLOSED
] as const satisfies readonly JobStatusId[]

const JOB_LIST_STATUS_OPTIONS = [
    { id: JOB_STATUS_IDS.DRAFT },
    { id: JOB_STATUS_IDS.IN_PROGRESS },
    { id: JOB_STATUS_IDS.CLOSED },
    { id: JOB_STATUS_IDS.CANCELLED }
] as const satisfies readonly { id: JobStatusId }[]

const JOB_IMPOSITIONS = {
    ELASTIC_NUMBER_FIELD_ID: 5,
    PLATE_TYPE_IDS: {
        DOES_NOT_APPLY: 7
    },
    PRINT_TYPE_IDS: {
        ONE_SIDED: 6
    }
} as const

const JOB_BINDING_PROCESS_IDS = [40, 41] as const

const JOB_COLOR_SETTINGS = {
    PANTONE_COLOUR_ID: 6,
    PRINT_COLOUR_TYPES: {
        BASIC: 'zwyczajny',
        PMS: 'PMS',
        LACQUER: 'lakier'
    },
    DEFAULT_USED_PERCENTS: {
        BASIC: 25,
        PMS: 70,
        LACQUER: 100
    }
} as const

export const JOBS = {
    STATUS_IDS: JOB_STATUS_IDS,
    LIST_FILTER_STATUS_IDS: JOB_LIST_FILTER_STATUS_IDS.join(','),
    LIST_FILTER_STATUS_IDS_ARRAY: [...JOB_LIST_FILTER_STATUS_IDS],
    LIST_STATUS_OPTIONS: JOB_LIST_STATUS_OPTIONS,
    PROOF_JOB_STATUS: {
        CLOSED: 100
    } as const,
    PACKAGE_PROTOTYPE_JOB_STATUS: {
        NEW: 10,
        CLOSED: 100
    } as const,
    MAX_WASTE_PERCENT: 25,
    PAPER_DESCRIPTION_MAX_LENGTH: 256,
    PRODUCTION_FILE_NAME_ILLEGAL_CHARACTERS: '/:\'"?*<>|()[]%$#@{}~^&',
    BINDING_PROCESS_IDS: JOB_BINDING_PROCESS_IDS,
    IMPOSITIONS: JOB_IMPOSITIONS,
    COLOR_SETTINGS: JOB_COLOR_SETTINGS
} as const
